module.exports = __webpack_public_path__ + "img/BAU Seniors_6.6ad9c8ab.jpg";